import {type IcManagementDid, IcManagementCanister} from '@icp-sdk/canisters/ic-management';
import {Principal} from '@icp-sdk/core/principal';
import {type ActorParameters, useOrInitAgent} from '@junobuild/ic-client/actor';
import type {CdnParameters} from '../types/actor.params';

const listCanisterSnapshots = async ({
  actor,
  canisterId
}: {
  actor: ActorParameters;
  canisterId: Principal;
}): Promise<IcManagementDid.list_canister_snapshots_result> => {
  const agent = await useOrInitAgent(actor);

  const {listCanisterSnapshots} = IcManagementCanister.create({
    agent
  });

  return listCanisterSnapshots({canisterId});
};

const takeCanisterSnapshot = async ({
  actor,
  ...rest
}: {
  actor: ActorParameters;
  canisterId: Principal;
  snapshotId?: IcManagementDid.snapshot_id;
}): Promise<IcManagementDid.take_canister_snapshot_result> => {
  const agent = await useOrInitAgent(actor);

  const {takeCanisterSnapshot} = IcManagementCanister.create({
    agent
  });

  return takeCanisterSnapshot(rest);
};

export const createSnapshot = async ({cdn}: {cdn: CdnParameters}) => {
  const mapParams = (): {actor: ActorParameters; canisterId: Principal} => {
    if ('satellite' in cdn) {
      const {
        satellite: {satelliteId, ...rest}
      } = cdn;
      return {
        canisterId: satelliteId instanceof Principal ? satelliteId : Principal.from(satelliteId),
        actor: rest
      };
    }

    const {
      console: {consoleId, ...rest}
    } = cdn;
    return {
      canisterId: consoleId instanceof Principal ? consoleId : Principal.from(consoleId),
      actor: rest
    };
  };

  const params = mapParams();

  const snapshots = await listCanisterSnapshots(params);

  // TODO: currently only one snapshot per canister is supported on the IC
  await takeCanisterSnapshot({
    ...params,
    snapshotId: snapshots?.[0]?.id
  });
};
